import { BaseContainerModel } from '../base-container.model';

export class PgwRequestModel extends BaseContainerModel {
  constructor(
    public merchantCode: string,
    public refNo: string,
    public amount: string,
    public currency: string,
    public userName: string,
    public userEmail: string,
    public userContact: string,
    public successPageUrl: string,
    public errorPageUrl: string,
    public serverDirectUrl: string,
    public serverIndirectUrl: string,
    public signature: string,
    public description: string,
    public items: string,
    public paymentChannelCode?: string,
    public paymentIdCode?: string,
    public installmentPeriod?: number
  ) {
    super();
  }
}

